import React from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { Carousel, CarouselItem } from "shared/ui/carousel/Carousel"

import {
  BuildingReferencePageGeneralInfo,
  BuildingReferencePageGeneralInfoViewModel
} from "./components/BuildingReferencePageGeneralInfo"
import "./styles/_building-reference-page.scss"

export interface InstallationReferenceItem {
  key: string
  title: React.ReactNode
  // titleSlot?: React.ReactNode
  content: React.ReactNode
}

export interface BuildingReferencePageViewModel {
  breadcrumbSlot: React.ReactNode
  titleSlot: React.ReactNode
  images?: CarouselItem[]
  installationReferences: InstallationReferenceItem[]

  productFilterOptions: SelectOption<string>[]
  activeProductFilters: string[]
  isLoading?: boolean
  onActiveProductFiltersChange: (options: string[]) => void

  generalInfoViewModel: BuildingReferencePageGeneralInfoViewModel
}

export const BuildingReferencePageView = React.memo(
  ({
    breadcrumbSlot,
    titleSlot,
    images,
    generalInfoViewModel,
    installationReferences,
    isLoading
  }: BuildingReferencePageViewModel) => {
    const { t } = useTranslation()

    const { tags, city } = generalInfoViewModel

    return (
      <div className="building-reference-page">
        <div className="building-reference-page__breadcrumb page-breadcrumb">
          {breadcrumbSlot}
        </div>

        <div className="building-reference-page__title">
          <h1>{titleSlot}</h1>
        </div>

        <div className="building-reference-page__tags">
          {tags?.length ? tags.map(tag => tag.title).join(", ") : null}
          {tags?.length && city ? " | " : null}
          {city}
        </div>

        <div className="building-reference-page__carousel-info">
          <Carousel
            className="building-reference-page__carousel card card--elevated"
            items={images}
            hideIndicatorForMultiItems
          />

          <BuildingReferencePageGeneralInfo
            isLoading={isLoading}
            className="building-reference-page__general-info card card--elevated"
            {...generalInfoViewModel}
          />
        </div>

        <div className="installation-reference-list card card--elevated">
          <div className="installation-reference-list__header">
            <h2 className="installation-reference-list__title">
              {t("InstallationReference.InstallationReferences")}
            </h2>
          </div>

          <div className="installation-reference-list__items">
            {installationReferences.map(item => (
              <div
                key={item.key}
                className="installation-reference-list__item"
                id={item.key}
              >
                <h3 className="installation-reference-list__item-title">
                  {item.title}
                </h3>

                <div className="installation-reference-list__item-content">
                  {item.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
)
